import "./App.css";
import axios from "axios";
import { AuthProvider } from "./context/AuthContext";
import AppContent from "./components/AppContent";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { ModuleRegistry } from "ag-grid-community";
import { LicenseManager, SetFilterModule } from "ag-grid-enterprise";

ModuleRegistry.registerModules([SetFilterModule]);
LicenseManager.setLicenseKey(
  process.env.REACT_APP_AG_GRID_LICENSE_KEY || "your License Key"
);

// No global 403 interceptor needed — viewer write-blocked responses are handled

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </div>
  );
}

export default App;
